import usePrivateKey from "hooks/usePrivateKey";
import Unauthorized from "pages/maintenance/unautorized";
import { useCallback, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { invoiceApiServices } from "utils/axios";
import { encrypt, decrypt, setEncryptedItem, getDomainName, createToken } from "utils/commonFunctions";
import useLocalStorage from 'hooks/useLocalStorage';

const domain = getDomainName();

const UserGuard = ({ children }: any) => {
    const [cookies] = useCookies(['loginCookie', 'expireCookie', 'instanceCookie']);
    const [accessGranted, setAccessGranted] = useState(false);
    const [invoiceUrl, setInvoiceUrl] = useState('');

    const { privateKey, encryptionKey, setUserRights,setInstanceName } = usePrivateKey();
    const isIONetgateDomain = domain.includes('io-netgate');
    const isIOMDomain = domain?.toLowerCase().replace(/-/g, '').includes('iomarket') ?? false;
    const [logoImage,setLogoImage]= useLocalStorage('logoImage', '');
    const [whiteLogoImage,setWhiteLogoImage]=useLocalStorage('whiteLogoImage', '');

    const userRightsFetch = useCallback(async () => {
        

        if (isIOMDomain) {
            const expireCookie = cookies?.expireCookie;
            if (expireCookie) {
                setAccessGranted(true);
                const userDetails: any = decrypt(expireCookie) ? JSON.parse(decrypt(expireCookie)) : {};
                setEncryptedItem('partyID', userDetails['partyID']);
                setEncryptedItem('userID', userDetails['userID']);
                setEncryptedItem('accId', userDetails['accId']);
                setEncryptedItem('netcomId', userDetails['netcomId']);
            } else {
                setAccessGranted(false);
                const ACCOUNT_URL = import.meta.env.VITE_APP_ACCOUNT_URL || 'https://accounts.io-market.net/';
                const encryptedData: any = encrypt(window.location.href, encryptionKey);
                window.location.replace(ACCOUNT_URL + '#/auth/login/' + encodeURIComponent(encryptedData));
            }
        } else if (isIONetgateDomain) {
            // const REDIRECT_LOGIN_ARRAY = import.meta.env.VITE_APP_REDIRECT_LOGIN ? JSON.parse(import.meta.env.VITE_APP_REDIRECT_LOGIN) : undefined;
            const INSTANCE_COOKIE = cookies?.instanceCookie ? JSON.parse(decrypt(cookies.instanceCookie)) : undefined;
            const LOGIN_COOKIE = cookies?.loginCookie ? JSON.parse(decrypt(cookies?.loginCookie)) : undefined;

            const INVOICE_URL:any = INSTANCE_COOKIE ? `https://${INSTANCE_COOKIE['instance']}.${domain}` :undefined
            localStorage.setItem('instanceName', INSTANCE_COOKIE?.instance || '');
            if (LOGIN_COOKIE && INSTANCE_COOKIE) {
                setAccessGranted(true);
                setInstanceName(INSTANCE_COOKIE['instance'])
                console.log("INSTANCE_COOKIE",INSTANCE_COOKIE)
                const Logoimg =  (INSTANCE_COOKIE.logo || '').replace(/\"/g, '');
                setLogoImage(Logoimg);
                setWhiteLogoImage(INSTANCE_COOKIE.whiteLogo || '');
                // localStorage.setItem('logoImage',Logoimg);
                // localStorage.setItem('whiteLogoImage',INSTANCE_COOKIE.whiteLogo);
                try {
                    let dataObj = {
                        "instanceId": INSTANCE_COOKIE.instanceId,
                        "companyUserId": LOGIN_COOKIE.companyUserId,
                        "userId": LOGIN_COOKIE.userId,
                    }
                    const tokenUser = createToken(dataObj, privateKey);
                    const encryptedTokenUser: any = encrypt(tokenUser, encryptionKey);

                    const formData = new FormData();
                    formData.append("encrToken", encryptedTokenUser);
                    const response = await invoiceApiServices.post("/main/userRights", formData);

                    if (response.data.STATUS && response.data.STATUS) {
                        setUserRights(response.data.DATA)
                    }
                } catch (error) {

                }
                // let userDetails: any = decrypt(expireCookie) ? JSON.parse(decrypt(expireCookie)) : {};
                // setEncryptedItem('partyID', userDetails['partyID']);
                // setEncryptedItem('userID', userDetails['userID']);
                // setEncryptedItem('accId', userDetails['accId']);
            } else {
                setAccessGranted(false);
                setInvoiceUrl(INVOICE_URL);
            }
        }
    }, [cookies, privateKey, encryptionKey])

    useEffect(() => {
        userRightsFetch()
    }, [userRightsFetch]);


    return accessGranted ? children : isIONetgateDomain && <Unauthorized redirectUrl={invoiceUrl} />;
}

export default UserGuard